export function getContactCopy(locale: string) {
  return locale.startsWith('cs')
    ? {
        returnsTitle: 'Vrácení a reklamace',
        returnsDescription: 'Informace o možnostech vrácení a reklamace zboží najdete na stránce',
        customerService: 'Zákaznický servis',
        supportHours: 'Provozní doba zákaznické linky',
        weekdays: 'Po-Pá: 8:00 - 16:00',
        headquarters: 'Sídlo společnosti',
        billingDetails: 'Fakturační údaje',
        registerSection: 'Oddíl: Sro',
        registerEntry: 'Číslo vložky',
        bankDetails: 'Bankovní spojení',
        formTitle: 'Kontaktní formulář',
        navigate: 'Navigovat na adresu',
        name: 'Jméno',
      }
    : {
        returnsTitle: 'Vrátenie a reklamácia',
        returnsDescription: 'Informácie o možnostiach vrátenia a reklamácia tovaru nájde na stránke',
        customerService: 'Zákaznícky servis',
        supportHours: 'Prevádzková doba zákazníckej linky',
        weekdays: 'Po-Pia: 8:00 - 16:00',
        headquarters: 'Sídlo spoločnosti',
        billingDetails: 'Fakturačné údaje',
        registerSection: 'Oddiel: Sro',
        registerEntry: 'Vložka číslo',
        bankDetails: 'Bankové spojenie',
        formTitle: 'Kontaktný formulár',
        navigate: 'Navigovať na adresu',
        name: 'Meno',
      };
}
